'use client';

import styled from 'styled-components';

export const PopupWrapper = styled.div`
  position: fixed;
  bottom: 24px;
  right: 24px;
  width: 320px;
  background: #ffffff;
  border-radius: 8px;
  box-shadow: 0 4px 16px rgba(0, 0, 0, 0.2);
  font-family: Arial, sans-serif;
  z-index: 1000;
  overflow: hidden;

  @media (max-width: 768px) {
    width: 280px;
    bottom: 20px;
    right: 20px;
  }

  @media (max-width: 480px) {
    bottom: 16px;
    left: 16px;
    right: 16px;
    width: auto;
  }
`;

export const Header = styled.div`
  background: #2c3e50;
  color: #fff;
  padding: 12px 16px;
  display: flex;
  justify-content: space-between;
  align-items: center;
`;

export const Title = styled.div`
  font-size: 16px;
  font-weight: bold;
`;

export const CloseButton = styled.button`
  background: transparent;
  border: none;
  color: #fff;
  font-size: 18px;
  cursor: pointer;
  line-height: 1;
  &:hover {
    color: #e74c3c;
  }
`;

export const WebinarList = styled.div`
  max-height: 300px;
  overflow-y: auto;
`;

export const WebinarItem = styled.div`
  padding: 12px 16px;
  border-bottom: 1px solid #ecf0f1;
  &:last-child {
    border-bottom: none;
  }
`;

export const WebinarTitle = styled.div`
  font-size: 14px;
  font-weight: 600;
  color: #2c3e50;
  margin-bottom: 4px;
`;

export const WebinarTime = styled.div`
  font-size: 12px;
  color: #7f8c8d;
  margin-bottom: 6px;
`;

export const WebinarLink = styled.a`
  display: inline-flex;
  align-items: center;
  padding: 8px 12px;
  background-color: #2d8cff;
  color: #ffffff;
  border-radius: 4px;
  font-size: 12px;
  font-weight: 500;
  text-decoration: none;
  transition: background-color 0.2s;
  &:hover {
    background-color: #1a72ff;
  }
  svg {
    margin-right: 6px;
  }
`;
